<template>
    <v-text-field
        :key="key"
        ref="option"
        :hint="$t('carsRent.from_18_to_120').toLocaleLowerCase()"
        :name="name"
        :prefix="`${$t('age')}:`"
        :rules="required ? [requiredRule('age')] : []"
        :model-value="age"
        bg-color="white"
        class="input--no-arrows"
        data-cy="adults-selector"
        type="number"
        variant="outlined"
        theme="light"
        single-line
        hide-details="auto"
        @update:model-value="inputAge"
    />
</template>

<script lang="ts">
    import {Component, Prop, VModel} from 'vue-facing-decorator'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    @Component
    export class AgeSelect extends FormValidationRulesMixin {
        @VModel() age
        @Prop({required: true}) name
        @Prop({default: false, type: Boolean}) disabled
        @Prop({default: false, type: Boolean}) required

        key = 0

        inputAge(v) {
            if (!v) {
                this.age = null
                return
            }
            let value = parseInt(v.length > 3 ? v.slice(-1) : v, 10)
            if (value < 18 && String(value).length > 1) value = 18
            else if (value === 0 && String(value).length <= 1) value = 18
            else if (value > 120) value = 120
            if (this.age === value) this.key++
            this.age = value
        }
    }

    export default AgeSelect
</script>
